import React from "react";
import CommonButton from "./CommonButton";

interface MediaUploadCompProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    type?: "image" | "video";
    showStar?: boolean
    aspectRatio?: string;
    onFileSelect?: (file: File) => void;
}

const MediaUploadComp: React.FC<MediaUploadCompProps> = ({
    label,
    value,
    onChange,
    type = "image",
    showStar,
    aspectRatio = "aspect-square",
    onFileSelect,
}) => {
    return (
        <div>
            <label className="pb-2 block flex items-center gap-1">
                <p className="text-md text-mainBrandColor">{label}</p>
                {showStar && (
                    <p className="text-md text-red-500">*</p>
                )}
            </label>

            {/* Upload Box */}
            <label className={`border-2 border-dashed border-gray-300 rounded-xl ${aspectRatio} w-full flex items-center justify-center overflow-hidden cursor-pointer bg-gray-50 hover:border-[#6DBE45] transition-all`}>

                {value ? (
                    type === "image" ? (
                        <img
                            src={value}
                            alt={label}
                            className="w-full h-full object-contain"
                        />
                    ) : (
                        <video
                            src={value}
                            controls
                            className="w-full h-full object-contain"
                        />
                    )
                ) : (
                    <div className="text-center">
                        <p className="text-gray-500 text-sm">
                            Upload {label}
                        </p>
                    </div>
                )}

                <input
                    type="file"
                    accept={
                        type === "image"
                            ? "image/*"
                            : "video/*"
                    }
                    className="hidden"
                    onChange={(e) => {
                        const file = e.target.files?.[0];

                        if (file) {
                            onFileSelect?.(file);

                            onChange(
                                URL.createObjectURL(file)
                            );
                        }
                    }}
                />
            </label>

            {/* Bottom Buttons */}
            {value && (
                <div className="flex items-center justify-center gap-3 mt-3">

                    {/* Change */}
                    <label className="bg-accent text-white px-4 py-2 rounded-lg text-sm cursor-pointer hover:opacity-90 transition-all">
                        Change

                        <input
                            type="file"
                            accept={
                                type === "image"
                                    ? "image/*"
                                    : "video/*"
                            }
                            className="hidden"
                            onChange={(e) => {
                                const file =
                                    e.target.files?.[0];

                                if (file) {
                                    onChange(
                                        URL.createObjectURL(file)
                                    );
                                }
                            }}
                        />
                    </label>

                    {/* Remove */}
                    <CommonButton
                        text="Remove"
                        variant="filled"
                        rounded="md"
                        className="bg-red-500 hover:bg-red-600"
                        onClick={() => onChange("")}
                        textContainerClassName="px-4 py-2"
                    />
                </div>
            )}
        </div>
    );
};

export default MediaUploadComp;